import { render, staticRenderFns } from "./sizedBox.vue?vue&type=template&id=55bb9fba&"
import script from "./sizedBox.vue?vue&type=script&lang=js&"
export * from "./sizedBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports